import type { Product } from 'src/types';
import type { Meta } from './types';
import type { ClientMarket } from '@prisjakt/web-app-config/types/client-market';
import type { TranslateFunc } from 'src/components/translate';

export function graph(
  product: Product,
  meta: Meta,
  description: string,
  market: ClientMarket,
  t: TranslateFunc
) {
  return [
    {
      key: 'title',
      content: t('meta', 'product.og-title', meta),
    },
    { key: 'description', content: description },
    {
      key: 'url',
      content: market.domain + product.pathName,
    },
    { key: 'type', content: 'product' },
    product.priceSummary && {
      key: 'amount',
      content: product.priceSummary.regular || product.priceSummary.alternative,
    },
    {
      key: 'currency',
      content: market.currency,
    },
    product.category && {
      key: 'category',
      content: product.category.name,
    },
    product.media && { key: 'image', content: product.media.first },
  ].filter(Boolean);
}
